// 接口网关标识
export const GATEWAYSER = {
  // 在线客服
  BAS: 'basicdata',
  OPE: 'operatingplatform',
  CSSPDD: 'servicequalityonline',
  SER: 'servicequality',
  SQSIM: 'ylwebsqsserviceonline',
  // 质检系统
  SQSQT: 'sqsqtmanageweb',
  // 普通工单
  WKD: 'sqsworkorder',
  // 第三方小前台
  SQSTHIRD: 'sqsthird',
  PJD:'sqsprojectorder',
  BPO:'bpo',
  SQS_CUSTOMER:'sqscustomersupportweb'
}


export const BAS = {
  key: 'BAS',
  routeflag: 'basicInformationIndex'
}
export const NET = {
  key: 'NET',
  routeflag: 'networkManagementIndex'
}
export const BUS = {
  key: 'BUS',
  routeflag: 'businessIndicatorIndex'
}
export const CUS = {
  key: 'CUS',
  routeflag: 'customerPlatformIndex'
}
export const DAT = {
  key: 'DAT',
  routeflag: 'dataCabinndex'
}
export const FIN = {
  key: 'FIN',
  routeflag: 'financialManagementIndex'
}
export const INT = {
  key: 'INT',
  routeflag: 'integratedServicesIndex'
}
export const OPE = {
  key: 'OPE',
  routeflag: 'operatingPlatformIndex'
}
export const SER = {
  key: 'SER',
  routeflag: 'serviceQualityIndex'
}
export const SMA = {
  key: 'SMA',
  routeflag: 'smartDeviceIndex'
}
export const TRA = {
  key: 'TRA',
  routeflag: 'transportPlatformIndex'
}
export const NOTICE = {
  key: 'NOTICE',
  // 公告放综合业务
  routeflag: 'integratedServicesIndex'
}

export const COM = {
  key: 'COM',
  routeflag: 'communityManagementIndex'
}
export const NEWFN = {
  key: 'NEWFN',
  routeflag: 'financialReportWebIndex'
}
export const TRSUB = {
  key: 'TRSUB',
  routeflag: 'transportSub'
}
export const PMI = {
  key: 'PMI',
  routeflag: 'projectManageIndex'
}
export const SERIM = {
  key: 'SERIM',
  routeflag: 'serviceQualityImIndex'
}
export const SERWO = {
  key: 'SERWO',
  routeflag: 'serviceQualityWoIndex'
}
export const SERQT = {
  key: 'SERQT',
  routeflag: 'serviceQualityQtIndex'
}
export const SQSDBI = {
  key: 'SQSDBI',
  routeflag: 'sqsDataBoardIndex'
}
export const CUSLC = {
  key: 'CUSLC',
  routeflag: 'customerPlatformLowCode'
}

// 接口网关标识
export const GATEWAY = {
  // 基础数据
  [BAS.key]: 'basicdata',
  // 智能设备
  [SMA.key]: 'smartdevice',
  // 客户平台
  [CUS.key]: 'customerplatform',
  // 操作平台
  [OPE.key]: 'operatingplatform',
  // 财务结算
  [FIN.key]: 'financialmanagement',
  // 运力平台
  [TRA.key]: 'transportation',
  // 网点经营
  [NET.key]: 'networkmanagement',
  // 综合业务
  [INT.key]: 'integratedservices',
  // 经营指标
  [BUS.key]: 'businessindicator',
  // [BUS.key]: 'businessplan',
  // 数据架舱
  [DAT.key]: 'datacabin',
  // 服务质量
  [SER.key]: 'servicequality',
  // 公告系统
  [NOTICE.key]: 'notice',
  // 社区管理
  [COM.key]: 'community',
  [NEWFN.key]: 'financialReportWebIndex',
  [TRSUB.key]: 'transportSub',
  [PMI.key]: 'projectManageIndex',
  [SERIM.key]: 'SERIM',
  [SERWO.key]: 'SERWO',
  [SERQT.key]: 'SERQT',
  [SQSDBI.key]: 'SQSDBI',
  [CUSLC.key]: 'CUSLC',
  // 物料模块
  MAT: 'materialservice',
  // 客户资料
  CUST: 'customerinfo',
  // 物料模块
  webOauth: 'webOauth'
}
// 生产域名地址
export const PRODADDRESS = 'weboutsoured.jtexpress.com.cn'
export default {
  GATEWAY,
  GATEWAYSER,
  PRODADDRESS
}
